import {
    ComponentFactoryResolver,
    Injectable,
    Injector,
    ViewContainerRef,
} from '@angular/core';
import { CustomToastrComponent } from '../components/common/custom-toastr/custom-toastr.component';
import { MessageService } from 'primeng/api';

@Injectable({
    providedIn: 'root',
})
export class CustomToastrService {
  private toastrComponent!: CustomToastrComponent;

  setToastrComponent(toastr: CustomToastrComponent) {
    this.toastrComponent = toastr;
  }

  showSuccess(message: string, duration: number = 3000) {
    if (this.toastrComponent) {
      this.toastrComponent.show(message, 'success', duration);
    }
  }

  showError(message: string, duration: number = 3000) {
    if (this.toastrComponent) {
      this.toastrComponent.show(message, 'error', duration);
    }
  }

  showWarning(message: string, duration: number = 3000) {
    if (this.toastrComponent) {
      this.toastrComponent.show(message, 'warning', duration);
    }
  }
}
